import { FC } from 'react';
import { Tooltip } from 'antd';
import { convertMinsToHrsMins } from 'src/utils/string';

import './index.style.scss';

type Indicator = {
  color: string;
  percentage: number;
  value: number;
};

interface ProgressBarDoubleProps {
  budget: number;
  available: Indicator;
  estimated: Indicator;
  spent: Indicator;
}

const ProgressBarLite: FC<ProgressBarDoubleProps> = ({
  budget,
  available,
  estimated,
  spent,
}) => {
  const segments = [
    { ...spent, label: 'Spent' },
    { ...estimated, label: 'Estimate' },
    { ...available, label: 'Available' },
  ];

  return (
    <div className="progressBarContainer">
      <div className="progressBar gap-x-[1px]">
        {segments.map((segment, index) => {
          const width = segment.percentage;

          const tooltipTitle = (
            <div>
              <span>{segment.label}:</span>{' '}
              {convertMinsToHrsMins(segment.value)} h <br />
            </div>
          );

          return (
            <Tooltip
              title={tooltipTitle}
              key={index}
              placement="top"
              className={
                segments.length - 1 !== index ? 'progressBarSegment' : ''
              }
            >
              <div
                className="segment"
                style={{
                  width: `${width}%`,
                  backgroundColor: segment.color,
                }}
              />
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBarLite;
